module.exports = __webpack_public_path__ + "static/img/album02_1.e705844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album02/album02_1.png
// module id = yXjQ
// module chunks = 1